/** Fill `:param` segments. Throws on a missing param so a bad call fails loudly in dev and tests. */
export function buildPath(path: string, params: Record<string, string | number> = {}): string {
  return path.replace(/:([A-Za-z_]+)/g, (_, name: string) => {
    const v = params[name];
    if (v === undefined) throw new Error(`missing path param ${name} for ${path}`);
    return encodeURIComponent(String(v));
  });
}
